import React from 'react';
import { Transaction } from '@alien-platform/bo-core';

import { Row } from '@/types/general';
import { HorizontalTable } from '@/components/core/horizontal-table';

export function TransactionDetailsTable({ transactionData }: { transactionData: Transaction }): React.JSX.Element {
  const tableData: Row[] = [
    {
      label: {
        text: 'Amount',
      },
      value: {
        text: `${transactionData?.fromAmount || 0}`,
      },
    },
    {
      label: {
        text: 'Transaction ID',
      },
      value: {
        text: transactionData?.txId,
      },
    },
    {
      label: {
        text: 'Balance Before',
      },
      value: {
        text: transactionData?.balanceBefore,
      },
    },
    {
      label: {
        text: 'Balance After',
      },
      value: {
        text: transactionData?.balanceAfter,
      },
    },

    {
      label: {
        text: 'Gateway',
      },
      value: {
        text: `${transactionData?.gatewayDetails?.title['en']}`,
      },
    },
  ];

  return <HorizontalTable header="Deposit Details" status={transactionData.status} tableData={tableData} />;
}
